import { Injectable } from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class NpsUtilsService {

  getNpsStatus(nps: number) {
    if (nps >= -100 && nps < 20) return 'qualifys.very_bad';
    if (nps >= 20 && nps <= 35) return 'qualifys.bad';
    if (nps > 35 && nps <= 50) return 'qualifys.regular';
    if (nps > 50 && nps <= 65) return 'qualifys.good';
    if (nps > 65 && nps <= 100) return 'qualifys.excellent';
  }
}